<template>
<section class=" flex md:flex-col">
    <div>
        <AdminDashboardNav/>
    </div>
    <section class="font-poppins w-screen pl-10 pr-10  md:pl-1 md:pr-1">
        <section class="mt-6">
            <div class=" flex justify-between md:flex-col-reverse">
                <div class="md:mt-6">
                    <GetDate/>
                    <p class="text-blue-700 font-bold text-2xl md:text-lg">MANAGE ORDERS</p>
                </div>

                <div class=" mr-10">
                    <Notification/>
                </div>
            </div>
        </section>

        <section>
            <div>
                <OrdersList/>
            </div>
        </section>
    </section>
</section>    
</template>

<script>
import GetDate from '../GetDate.vue';
import AdminDashboardNav from '../AdminDashboardNav.vue';
import Notification from '../Notification.vue';
import OrdersList from '../Orders/OrdersList.vue';
export default {
    components : {
        AdminDashboardNav,
        GetDate,
        Notification,
        OrdersList
    },

    data() {
        return {
            filter: '',
            search: ''
        }
    },
    mounted() {
        this.networkError();
    },

    methods: {
        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
    
}
</script>